function centsToDollars(cents, options={}) {
  var hideCents = options.hide_cents;
  if (hideCents === 'auto') { hideCents = cents % 100 === 0; }
  var display = formatNumCommas((parseFloat(cents) / 100).toFixed(hideCents ? 0 : 2));
  return options.dollar_sign === false ? display : '$' + display;
}

function formatNumCommas(num) {
  if (num === null) { return '' }
  var negative = num < 0;
  var decSplit = num.toString().split('.');
  var digitArray = Array.from(decSplit[0]);
  var display = '';

  if (negative) {
    digitArray.shift();
  }

  digitArray.forEach((digit, i) => {
    display += digit;
    if ((digitArray.length - i - 1) % 3 === 0) { display += ','; }
  });

  display = display.replace(/,\s*$/, "");
  if (decSplit[1]) {
    var decimalPad = (decSplit[0] === "") ? '0.' : '.';
    display += decimalPad + decSplit[1];
  }
  if (negative) {
    display = '-' + display;
  }
  return display;
}

export { centsToDollars, formatNumCommas }
